import { useState } from 'react'
import { ButtonBase, Typography, alpha } from '@mui/material'
import BoxWithBorder from 'components/atoms/container/BoxWithBorder'
import BlankRect from 'components/atoms/BlankRect'
import RowStack from 'components/atoms/container/RowStack'
import InCardStack from 'components/atoms/container/InCardStack'
import ProfileAvatar from 'components/atoms/ProfileAvatar'
import { useNavigate } from 'react-router-dom'
import { getFullName } from 'utils/formatText'
import { getUserConnectionLabel } from 'utils/getSupportingInfo'
import { Tag } from 'components/atoms/Text'
import { MY_CONTACT, MEETINGS } from 'routes/constants'
import { useTranslation } from 'react-i18next'
import colors from 'styles/colors'
import { ReactComponent as DeletedUserImage } from 'assets/images/deletedUser.svg'
import CommonDialog from 'components/molecules/notificationOverlay/CommonDialog'

const ConnectionUserItem = ({
  c,
  showSkeleton = false,
  openTeamView = () => {}
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [openDialog, setOpenDialog] = useState(false)
  const isDirectReport = c?.relationship === 'direct_report'
  const isDirectSupervisor = c?.relationship === 'direct_supervisor'
  const userDeletedAt = c?.user?.deletedAt
  const boxAttrs = {
    borderWidth: 1,
    borderColor: colors.Grey200,
    padding: 8,
    borderRadius: 4,
    width: 332,
    minHeight: 156
  }
  const textStyle = {
    noWrap: true,
    width: '100%',
    textAlign: 'left'
  }
  return (
    <>
      {!showSkeleton ? (
        <ButtonBase
          data-testid={`contact-button-${c.id}`}
          onClick={() => {
            if (!userDeletedAt)
              navigate(`${MY_CONTACT}/${c.id}`, { state: { from: MEETINGS } })
            else setOpenDialog(true)
          }}>
          <BoxWithBorder {...boxAttrs}>
            <InCardStack spacing={4}>
              <RowStack justifyContent='space-between'>
                {userDeletedAt ? (
                  <DeletedUserImage />
                ) : (
                  <>
                    <ProfileAvatar user={c.user} size={'conn'} />
                    <Tag
                      sx={{
                        paddingX: 2,
                        paddingY: 1,
                        fontWeight: 500,
                        background:
                          isDirectReport || isDirectSupervisor
                            ? alpha(colors.SuccessGreen, 0.2)
                            : colors.Grey
                      }}>
                      {getUserConnectionLabel(c.relationship, t)}
                    </Tag>
                  </>
                )}
              </RowStack>

              <InCardStack width='100%' spacing={0}>
                {(c.user?.firstName || c.user?.first_name) && (
                  <Typography variant='h4' {...textStyle}>
                    {userDeletedAt
                      ? t('contact.deletedUser', {
                          firstName: c.user?.firstName || c.user?.first_name
                        })
                      : getFullName(c.user)}
                  </Typography>
                )}
                {c.user?.email && (
                  <Typography {...textStyle}>
                    {userDeletedAt
                      ? t('contact.userAccountDeleted')
                      : c.user?.email}
                  </Typography>
                )}
              </InCardStack>
            </InCardStack>
          </BoxWithBorder>
        </ButtonBase>
      ) : (
        <BoxWithBorder {...boxAttrs}>
          <InCardStack spacing={4}>
            <RowStack justifyContent='space-between'>
              <BlankRect
                w={64}
                h={64}
                sx={{ borderRadius: 20, backgroundColor: colors.Grey100 }}
              />
              <BlankRect
                w={60}
                h={20}
                sx={{ borderRadius: 1, backgroundColor: colors.Grey100 }}
              />
            </RowStack>
            <InCardStack width='100%' spacing={2} alignItems={'flex-start'}>
              <BlankRect
                w={152}
                h={22}
                sx={{ borderRadius: 1, backgroundColor: colors.Grey100 }}
              />
              <BlankRect
                w={206}
                h={14}
                sx={{ borderRadius: 1, backgroundColor: colors.Grey100 }}
              />
            </InCardStack>
          </InCardStack>
        </BoxWithBorder>
      )}

      <CommonDialog
        open={openDialog}
        onClose={value => {
          if (value === 0) {
            openTeamView(getFullName(c, true))
          }
          setOpenDialog(false)
        }}
        titleText={t('contact.userBeenDeleted')}
        notificationText={t('contact.pageNoLongerAvailable')}
        cancelText={t('myTeam.past1on1')}
        confirmText={t('rolePlay.okay')}
      />
    </>
  )
}

export default ConnectionUserItem
